<template>
  <div id="app">
    <v-card class="custom-card">
      <v-layout row wrap>
        <!-- Başlık -->
        <v-flex xs12>
          <v-toolbar dark color="#2196F3">
            <v-toolbar-title class="custom-title">{{ $t('Support') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="#4CAF50" @click="reloadPage"> Ticketları Güncelle</v-btn>
          </v-toolbar>
        </v-flex>

        <!-- Destek Sekmesi -->
        <v-flex xs12>
          <v-tabs v-model="active">
            <v-tab-item value="0">
              <v-container>
                <v-row>
                  <v-col v-for="(group, index) in groupedMessages" :key="index" cols="12" md="6">
                    <v-card class="custom-content-card" outlined>
                      <v-card-title class="custom-header">
                        <div>
                          <span class="ticket-title">Ticket</span>
                          <span class="ticket-date">
                            {{ group.AlisTarihi ? new Date(group.AlisTarihi).toLocaleDateString('tr-TR') : 'Tarih Yok'
                            }}
                          </span>
                        </div>

                        <v-btn :color="group.Status === 'Aktif' ? 'red' : 'green'"
                          :disabled="group.Status === 'Çözüldü'" class="status-btn" @click="updateStatus(group)">
                          {{ group.Status === 'Aktif' ? 'Aktif' : 'Çözüldü' }}
                        </v-btn>
                      </v-card-title>

                      <v-card-text class="custom-text">
                        <div v-html="group.Sorun"></div>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn color="primary" @click="showDetails(group)">
                          Mesajları Göster
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Destek Detayı -->
                <v-dialog v-model="dialog" max-width="600px">
                  <v-card>
                    <v-card-title class="custom-title">Mesajlar</v-card-title>
                    <v-card-text>
                      <div class="custom-chat-container">
                        <div v-for="(message, index) in currentItem.DestekListesi" :key="index"
                          :class="['custom-chat-bubble', index % 2 === 0 ? 'sent' : 'received']">
                          {{ message }}
                        </div>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn v-if="currentItem.Status === 'Aktif'" color="blue" @click="openSupportDialog">
                        ➕ Mesaj Gönder
                      </v-btn>
                      <v-btn color="grey" @click="dialog = false">❌ Kapat</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Destek Ekle -->
                <v-dialog v-model="supportDialog" max-width="500px">
                  <v-card>
                    <v-card-title>Yeni Destek Mesajı</v-card-title>
                    <v-card-text>
                      <v-textarea v-model="newSupportText" label="Destek Mesajı" outlined auto-grow
                        required></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" @click="saveSupport">Kaydet</v-btn>
                      <v-btn color="grey" @click="supportDialog = false">İptal</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>


<script>
import auth from '../../../api/auth'

export default {
  data() {
    return {
      active: "0",
      dialog: false,
      supportDialog: false,
      newSupportText: "",
      currentItem: {},
      messages: [],
      groupedMessages: [],
    };
  },

  mounted() {
    this.fetchMessages();
  },

  methods: {
    async fetchMessages() {
      const token = localStorage.getItem("token");
      if (!token) return;

      this.$http
        .post(auth.API_URL + "api/RegisterAuth/DsProblemSupport", null, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then(res => {
          this.messages = res.data;
          this.groupMessages();
        }).catch(err => {
          console.log(err);
        })
    },

    groupMessages() {
      const grouped = {};
      this.messages.forEach((msg) => {
        if (!grouped[msg.SorunRef]) {
          grouped[msg.SorunRef] = { ...msg, DestekListesi: [msg.Destek] };
        } else {
          grouped[msg.SorunRef].DestekListesi.push(msg.Destek);
        }
      });
      this.groupedMessages = Object.values(grouped);
    },

    async updateStatus(group) {
      if (group.Status === "Çözüldü") {
        alert("✅ Bu sorun zaten çözülmüştür.");
        return;
      }
      const params = { SorunID: group.SorunRef, Status: "Çözüldü" };
      this.$http
        .post(auth.API_URL + "api/ProblemsSupports/UpdateStatus", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then(res => {
          this.messages = res.data;
          this.groupMessages();
        }).catch(err => {
          console.log(err);
        })
      group.Status = "Çözüldü";
      alert(`✅ Bu sorun çözülmüştür.`);
    },

    showDetails(group) {
      this.currentItem = group;
      this.dialog = true;
    },

    openSupportDialog() {
      this.newSupportText = "";
      this.supportDialog = true;
    },

    async saveSupport() {
      const params = {
        SorunID: this.currentItem.SorunRef,
        DestekAciklama: this.newSupportText,
      };
      this.$http
        .post(auth.API_URL + "api/ProblemsSupports/SupportSaveAuto", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then(res => {
          this.currentItem.DestekListesi.push(this.newSupportText);
          this.supportDialog = false;
          alert("✅ Destek başarıyla kaydedildi!");
        }).catch(err => {
          console.log(err);
        })

    },

    reloadPage() {
      window.location.reload();
    },
  },
};
</script>



<style scoped>
/* Arkaplan ve başlık rengi */
.custom-card {
  background-color: #f5f5f7;
  padding: 20px;
  border-radius: 12px;
}

.custom-title {
  font-size: 22px;
  font-weight: bold;
}

.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-content-card {
  border: none;
  box-shadow: 0 4px 12px #b3d4fc;
  transition: transform 0.2s;
}

.custom-content-card:hover {
  transform: translateY(-5px);
}

.status-btn {
  font-size: 14px;
  text-transform: uppercase;
}

/* Yenile Butonu */
.v-btn {
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 8px;
}

/* Sohbet Mesajı Stil */
.custom-chat-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}

.custom-chat-bubble {
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.4;
  border-radius: 18px;
  max-width: 70%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.sent {
  align-self: flex-end;
  background-color: #007bff;
  color: white;
}

.received {
  align-self: flex-start;
  background-color: #f1f1f1;
  color: #2c3e50;
}

.custom-chat-container::-webkit-scrollbar {
  width: 6px;
}

.custom-chat-container::-webkit-scrollbar-thumb {
  background-color: #c5c5c5;
  border-radius: 8px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-chat-bubble {
  animation: fadeIn 0.3s ease forwards;
}
</style>
